import { IPersistor } from './IPersistor';

export class SessionStoragePersistor implements IPersistor {
  async get<T>(key: string): Promise<T | null> {
    try {
      const item = sessionStorage.getItem(key);
      return item ? JSON.parse(item) : null;
    } catch (error) {
      console.error('[SessionStoragePersistor] Get failed', error);
      return null;
    }
  }

  async set<T>(key: string, value: T): Promise<void> {
    try {
      sessionStorage.setItem(key, JSON.stringify(value));
    } catch (error) {
      console.error('[SessionStoragePersistor] Set failed', error);
    }
  }

  async delete(key: string): Promise<void> {
    try {
      sessionStorage.removeItem(key);
    } catch (error) {
      console.error('[SessionStoragePersistor] Delete failed', error);
    }
  }

  async clear(): Promise<void> {
    try {
      sessionStorage.clear();
    } catch (error) {
      console.error('[SessionStoragePersistor] Clear failed', error);
    }
  }
}
